import RegionNewItem from './RegionNewItem';

export default RegionNewItem;
